import { render, staticRenderFns } from "./commissionOldDeclareExtra.vue?vue&type=template&id=71d43918"
import script from "./commissionOldDeclareExtra.vue?vue&type=script&lang=js"
export * from "./commissionOldDeclareExtra.vue?vue&type=script&lang=js"
import style0 from "./commissionOldDeclareExtra.vue?vue&type=style&index=0&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports